export const getNationalities = (state) => state.nationalities
